module.exports = __webpack_public_path__ + "static/media/tutorial-stress.797143d7.png";